import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { RootState } from '@root/app.state';
import * as CoreActions from '@core/core.actions';
import { go } from '@platform/router.actions';
import { RouteGuard } from '@platform/routing/route.guard';
import { resourceLoadSucceeded } from '@platform/shared/resource.state';
import { selectUserOverview } from '@core/core.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserManagementGuard implements RouteGuard {
  constructor(private store$: Store<RootState>) {}

  async canActivate(): Promise<boolean> {
    return await this.preload();
  }

  async canActivateChild(): Promise<boolean> {
    return await this.preload();
  }

  private async preload(): Promise<boolean> {
    this.store$.dispatch(CoreActions.loadUserOverview());

    const canActivate = await resourceLoadSucceeded(this.store$, selectUserOverview);
    if (!canActivate) {
      this.store$.dispatch(go({ path: ['error'] }));
    }

    return canActivate;
  }
}
